<template>
	<section>
		<div class='container-fluid' id='footer'>

			<!-- Logos -->
			<div class='container'>									          
				<div class='row' style='padding-top: 40px;'>
					<div class='col-6' style='border-bottom: thin solid #a9aaa7;'>
						<img src='../assets/images/logo-white.png' style="padding: 20px 0px; height: 80px;" alt="Get a Better Rate Logo">
					</div>

					<div class='col-6 text-end' style='border-bottom: thin solid #a9aaa7;'>
						<a href="https://www.getabetterrate.com.au/contact" title="Get a Better Rate Mortgage Brokers" class="btn btn-primary">Speak to a broker</a>
					</div>

					<div class='col-6 col-lg-3' style='padding-top: 40px;'>							
						<strong style='color: #fff;'>Address</strong>
						<p>Level 16,  9 Castlereagh St<br>
							Sydney, Australia<br>
							<a href="https://www.getabetterrate.com.au" title="Get a Better Rate Australia">getabetterrate.com.au</a>
						</p>
					</div>

					<div class='col-12 col-lg-3' style='padding-top: 40px;'>		
						<p>
							<strong style='color: #fff;'>Founder & Principal Broker</strong><br>
							Peter Hammond<br><br>
							<a target="_blank" aria-label="Chat on WhatsApp" href="https://wa.me/61420991404" title="Chat on WhatsApp">
								<img alt="Chat on WhatsApp" src="../assets/images/WhatsAppButtonGreenSmall.svg"></a>
						</p>
					</div>

					<div class='col-12' style='padding-top: 20px;'>
						<p>© 2026 Loan Marketplace Pty Ltd ABN 42 634 181 301 trading as Get a Better Rate. 
							Credit Representative 518502, authorised under Australian Credit Licence 389087 of Australian Finance Group Ltd</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
  export default 
  { name: 'FooterPage' }
</script>